module.exports = __webpack_public_path__ + "img/ed002-principal.79806cf0.png";